
export interface IModalProps {
	onAcceptHandler?: () => void;
  onCancelHandler: () => void;
  title: string;
  hideAcceptButton?: boolean;
  warningText?: string;
	open: boolean;
}

export interface IModalConfiguration {
  title: string;
  warningText?: string;
  hideAcceptButton: boolean;
};

export const style = {
	position: 'absolute' as 'absolute',
	top: '50%',
	left: '50%',
	alignText: "center",
	transform: 'translate(-50%, -50%)',
	width: 480,
	bgcolor: 'background.paper',
	borderRatious: "50%",
	boxShadow: 24,
	p: 6,
	borderRadius: 2,
};